import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL || "https://api-gama.usios.valkeon.com", // Read from environment
  timeout: 300000, // 5 minutes in milliseconds
});

// Add a request interceptor to include Bearer token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for error handling or other logic
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && [401, 403].includes(error.response.status)) {
      // Handle unauthorized errors, e.g., redirect to login
      console.error("Unauthorized access - redirecting to login");
      // Add logic to handle token expiration or redirection if needed
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
